import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Portal,
} from "@mui/material";

import { Column } from "../../store/Column";

interface Props {
  column: Column;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const OverwriteColumnDialog: React.FC<Props> = ({
  column,
  open,
  onClose,
  onConfirm,
}) => {
  function handleClose() {
    onClose();
  }

  function handleConfirm() {
    onConfirm();
    handleClose();
  }

  return (
    <Portal>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Overwrite {column.label}?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {column.label} is not empty. Pasting to this column will overwrite
            its contents. Continue paste and overwite the column contents?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="text"
            autoFocus
            onClick={handleConfirm}
          >
            Overwrite
          </Button>
        </DialogActions>
      </Dialog>
    </Portal>
  );
};

export default OverwriteColumnDialog;
